import type { ReactNode } from 'react';

export type TriageFilter = 'all' | 'incident' | 'budget' | 'invoice';

export interface TriageCounts {
  incident: number;
  budget: number;
  invoice: number;
}

export interface TriageFilterBarProps {
  activeFilter: TriageFilter;
  onChange: (filter: TriageFilter) => void;
  counts: TriageCounts;
  /** When false the invoice pill is hidden regardless of its count (no invoicing permission). */
  canInvoice?: boolean;
  /** Optional node rendered at the end of the pill row (e.g. the warehouse alerts pill). */
  trailingSlot?: ReactNode;
  className?: string;
}

// Maps each triage filter to the real activity.type values it groups, used to
// build the server-side `types` filter. 'all' applies no filter.
export const TRIAGE_TYPE_MAP: Record<Exclude<TriageFilter, 'all'>, string[]> = {
  incident: ['Incident', 'Incident Acknowledgment'],
  budget: [
    'BUDGET_REQUEST_CREATED',
    'BUDGET_REQUEST_ACCEPTED',
    'BUDGET_REQUEST_REJECTED',
    'BUDGET_REQUEST_CANCELLED',
    'BUDGET_PROPOSAL_SUBMITTED',
    'BUDGET_PROPOSAL_ACCEPTED',
    'BUDGET_PROPOSAL_REJECTED',
    'BUDGET_PROPOSAL_COUNTERED',
  ],
  invoice: ['INVOICE_PENDING'],
};

export const triageFilterToTypes = (filter: TriageFilter): string[] | undefined =>
  filter === 'all' ? undefined : TRIAGE_TYPE_MAP[filter];
